import { useEffect, useState } from "react";
import Services from "../components/Services";
import { FaChevronLeft, FaChevronRight, FaStar, FaStarHalfAlt } from "react-icons/fa";
import { motion } from "framer-motion";
import usePageContent from "../utils/usePageContent";

const images = [
  "/images/hero-section/sliderimg1.jpg",
  "/images/hero-section/sliderimg2.jpg",
  "/images/hero-section/sliderimg3.jpg"
];

const galleryImages = [
  "/images/about-us/gallery1.jpg",
  "/images/about-us/gallery2.jpg",
  "/images/about-us/gallery3.jpg",
  "/images/about-us/gallery4.jpg"
];

const clientImages = [
  "/images/our-clients/searchkar.png",
  "/images/our-clients/pernod.png",
  "/images/our-clients/proximo.png",
  "/images/our-clients/rohit.png",
  "/images/our-clients/mogasun.png"
];

const Home = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [portfoliocurrentIndex, setPortfolioCurrentIndex] = useState(0);
  const [index, setIndex] = useState(0);

  const [selected, setSelected] = useState("photography");
  const portfolioimages = ["/images/portfolio-images/portfolio1.png", "/images/portfolio-images/portfolio2.png", "/images/portfolio-images/portfolio3.png"];
  const {
    herotitle,
    herodescription,
    abouttitle,
    aboutparagraph1,
    aboutparagraph2,
    servicestitle,
    servicesdescription,
    portfoliotitle,
    portfoliosubtitle,
    clientstitle,
    testimonialsSectiontitle,
    highlightedName,
    testimonials = []
  } = usePageContent('home');


  useEffect(() => {
    console.log(testimonialsSectiontitle)
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setPortfolioCurrentIndex((prevIndex) => (prevIndex + 1) % portfolioimages.length);
    }, 3000); // Change image every 3 seconds

    return () => clearInterval(interval); // Cleanup on unmount
  }, []);

  const prevTestimonial = () => {
    setIndex((prevIndex) => (prevIndex === 0 ? testimonials.length - 1 : prevIndex - 1));
  };

  const nextTestimonial = () => {
    setIndex((prevIndex) => (prevIndex === testimonials.length - 1 ? 0 : prevIndex + 1));
  };


  return (
    <div className="w-full">
      <div className="relative w-full h-screen overflow-hidden">
        <div
          className="absolute inset-0 flex w-full h-full transition-transform duration-1000"
          style={{ transform: `translateX(-${currentIndex * 100}%)` }}
        >
          {images.map((src, index) => (
            <img
              key={index}
              src={src}
              alt={`Slide ${index + 1}`}
              className="w-full h-full object-cover flex-shrink-0"
            />
          ))}
        </div>
        <div className="absolute left-10 top-1/2 transform -translate-y-1/2 text-white max-w-lg">
          <h1 className="text-4xl font-bold">{herotitle}</h1>
          <p className="mt-4 text-lg">{herodescription}</p>
        </div>
      </div>

      <div className="bg-black text-white py-16 px-10 flex flex-col md:flex-row gap-10">
        <div className="grid grid-cols-2 gap-4 w-full md:w-1/2">
          <img src={galleryImages[0]} alt="Gallery 1" className="w-full h-[300px] object-cover rounded-lg" />
          <div className="flex items-center justify-center">
            <img src={galleryImages[1]} alt="Gallery 2" className="w-3/4 h-[200px] object-cover rounded-lg" />
          </div>
          <img src={galleryImages[2]} alt="Gallery 3" className="w-full h-[300px] object-cover rounded-lg" />
          <div className="flex items-center justify-center">
            <img src={galleryImages[3]} alt="Gallery 4" className="w-3/4 h-[200px] object-cover rounded-lg" />
          </div>
        </div>
        <div className="w-full md:w-1/2 flex flex-col justify-center">
          <h2 className="text-3xl font-bold mb-6 inline-block relative after:content-[''] after:block after:w-full after:h-1 after:bg-red-700 after:mt-2">
            {abouttitle}
          </h2>
          <p className="mb-4">
            {aboutparagraph1}
          </p>
          <p>
            {aboutparagraph2}
          </p>
        </div>
      </div>


      <div className="mt-20 px-24 text-black">


        <h2 className="text-3xl font-bold inline-block pb-2 mb-0 relative after:content-[''] after:block after:w-full after:h-1 after:bg-red-700 after:mt-2">
          {servicestitle}
        </h2>

        <p className="text-lg">
          {servicesdescription}
        </p>
        <Services />
      </div>

      <div className="mt-10 px-6 sm:px-12 md:px-24 pb-24 text-black">
        {/* Title & Buttons */}
        <div className="flex flex-col md:flex-row md:justify-between md:items-center space-y-4 md:space-y-0">
          {/* Portfolio Title */}
          <h2 className="text-3xl font-bold inline-block pb-2 mb-0 relative after:content-[''] after:block after:w-full after:h-1 after:bg-red-700 after:mt-2">
            {portfoliotitle}
          </h2>

          {/* Category Buttons */}
          <div className="flex flex-wrap justify-center md:justify-end space-x-4 md:space-x-6 text-lg md:text-xl font-semibold">
            {["photography", "designs"].map((item) => (
              <button
                key={item}
                className={`relative pb-2 ${selected === item ? "text-red-700" : "text-gray-700"
                  }`}
                onClick={() => setSelected(item)}
              >
                {item.charAt(0).toUpperCase() + item.slice(1)}
                {selected === item && (
                  <span className="absolute left-0 bottom-[-6px] w-full h-1 bg-red-700"></span>
                )}
              </button>
            ))}
          </div>
        </div>

        {/* Subtitle */}
        <p className="text-lg mt-2 text-center md:text-left">
          {portfoliosubtitle}
        </p>

        {/* Image Slider */}
        <div className="overflow-hidden mt-6 w-full relative">
          <div
            className="flex transition-transform duration-700 ease-in-out"
            style={{ transform: `translateX(-${portfoliocurrentIndex * 100}%)` }}
          >
            {portfolioimages.map((src, index) => (
              <img
                key={index}
                src={src}
                alt={`Slide ${index}`}
                className="w-full h-auto aspect-[16/9] object-cover flex-shrink-0"
              />
            ))}
          </div>
        </div>
      </div>

      <div className="mt-6 px-0 pb-24 bg-black overflow-hidden w-full">
        <div className="mt-10 px-6 sm:px-12 md:px-24 text-black">
          <h2 className="text-3xl font-bold inline-block pb-2 mb-4 relative text-white after:content-[''] after:block after:w-full after:h-1 after:bg-red-700 after:mt-2 text-center">
            {clientstitle}
          </h2>
        </div>

        {/* Full-Width Scrolling Image Container */}
        <div className="relative w-full overflow-hidden">
          <div className="flex items-center space-x-6 animate-scroll">
            {[...clientImages, ...clientImages, ...clientImages, ...clientImages].map((src, index) => (
              <div
                key={index}
                className="bg-white p-2 rounded-xl shadow-lg flex items-center justify-center w-52 h-20"
              >
                <img
                  src={src}
                  className="h-full w-auto object-contain"
                  alt={`Client ${index + 1}`}
                />
              </div>
            ))}
          </div>
        </div>

      </div>

      <div className="mt-32 text-center mb-20">
        <h2 className="text-black text-6xl font-bold tracking-wide">{testimonialsSectiontitle}</h2>
        <h1 className="text-red-600 text-8xl font-extrabold mt-4">{highlightedName}</h1>

        <div className="relative mt-16 flex items-center justify-center">
          <button onClick={prevTestimonial} className="bg-red-600 text-white p-6 rounded-full shadow-lg mr-16">
            <FaChevronLeft size={32} />
          </button>

          <motion.div
            key={index}
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.8 }}
            transition={{ duration: 0.6, ease: "easeInOut" }}
            className="text-center mx-12"
          >
            {testimonials && testimonials.length > 1 && (
              <>
                <div className="flex justify-center mt-4">
                  {[...Array(Math.floor(testimonials[index].rating))].map((_, i) => (
                    <FaStar key={i} className="text-yellow-500 text-3xl" />
                  ))}
                  {testimonials[index].rating % 1 !== 0 && <FaStarHalfAlt className="text-yellow-500 text-3xl" />}
                </div>
                <h3 className="text-3xl font-semibold mt-6">{testimonials[index].name}</h3>
                <p className="text-gray-600 mt-4 max-w-lg mx-auto text-xl font-medium">{testimonials[index].review}</p>
              </>
            )}

          </motion.div>

          <button onClick={nextTestimonial} className="bg-red-600 text-white p-6 rounded-full shadow-lg ml-16">
            <FaChevronRight size={32} />
          </button>
        </div>

        <div className="flex justify-center mt-8 space-x-4">
          {testimonials.map((_, i) => (
            <div
              key={i}
              onClick={() => setIndex(i)}
              className={`w-5 h-5 rounded-full cursor-pointer transition-all duration-300 ${index === i ? 'bg-red-600 scale-150' : 'bg-gray-300'}`}
            ></div>
          ))}
        </div>
      </div>


    </div>
  );
};

export default Home;
